import { MoreHorizontal } from 'lucide-react';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { Button } from 'shared/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from 'shared/ui/dropdown-menu';
import type { EnvVarWithId } from '@/enteties/env-variables/model';
import * as m from '@paraglide/messages';
import type { Project } from '@/enteties/project/modal';
const EditForm = dynamic(() => import('features/edit-variable').then(module => module.EditForm));
const DeleteVariable = dynamic(() => import('features/delete-variable').then(module => module.DeleteVariable));
interface EditEnvVarProps {
  defaults: EnvVarWithId;
  slug: Project['slug'];
}
export const EnvVarActions = ({
  defaults,
  slug
}: EditEnvVarProps) => {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  return <div className="grid place-items-center" data-sentry-component="EnvVarActions" data-sentry-source-file="env-var-actions.tsx">
      <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-source-file="env-var-actions.tsx">
        <DropdownMenuTrigger asChild data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="env-var-actions.tsx">
          <Button variant="ghost" className="h-4 p-0" data-sentry-element="Button" data-sentry-source-file="env-var-actions.tsx">
            <span className="sr-only">Open menu</span>
            <MoreHorizontal className="size-4" data-sentry-element="MoreHorizontal" data-sentry-source-file="env-var-actions.tsx" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" data-sentry-element="DropdownMenuContent" data-sentry-source-file="env-var-actions.tsx">
          <DropdownMenuLabel data-sentry-element="DropdownMenuLabel" data-sentry-source-file="env-var-actions.tsx">{m.tab_envvars_table_actions()}</DropdownMenuLabel>
          <DropdownMenuItem onClick={() => setEditOpen(true)} data-sentry-element="DropdownMenuItem" data-sentry-source-file="env-var-actions.tsx">
            {m.tab_envvars_table_action_changeVar()}
          </DropdownMenuItem>
          <DropdownMenuSeparator data-sentry-element="DropdownMenuSeparator" data-sentry-source-file="env-var-actions.tsx" />
          <DropdownMenuItem className="text-destructive" onClick={() => setDeleteOpen(true)} data-sentry-element="DropdownMenuItem" data-sentry-source-file="env-var-actions.tsx">
            {m.tab_envvars_table_action_deleteVar()}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {editOpen && <EditForm open={editOpen} setOpen={setEditOpen} defaultValues={defaults} slug={slug} />}
      {deleteOpen && <DeleteVariable open={deleteOpen} setOpen={setDeleteOpen} name={defaults.name} id={defaults.id} slug={slug} />}
    </div>;
};